// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-sheet.v-card{border-radius:16px!important;box-shadow:0 0 30px rgba(46,35,94,.102)!important}@media(min-width:1024px){.margin-content{margin-top:30px}}.v-dialog{border-radius:16px!important}.v-simple-checkbox{align-self:center;line-height:normal;position:relative;-moz-user-select:none;user-select:none}.v-simple-checkbox .v-icon{cursor:pointer}.v-simple-checkbox--disabled{cursor:default}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
